import { default as SessionInfo } from './SessionInfo'
import { default as Map } from './Map'

const Sessions = {
    SessionInfo,
    Map
}

export default Sessions